// environment.ts
const baseUrl = window['env']?.baseUrl && !window['env'].baseUrl.startsWith('${') ? window['env'].baseUrl : 'https://didactbe.local';
const apiUniversityUrl =
	window['env']?.apiUniversityUrl && !window['env'].apiUniversityUrl.startsWith('${') ? window['env'].apiUniversityUrl : '/university';
const apiSchoolUrl =
	window['env']?.apiSchoolUrl && !window['env'].apiSchoolUrl.startsWith('${') ? window['env'].apiSchoolUrl : '/school_university';

export const environment = {
	production: false,
	baseUrl,
	apiUrl: `${baseUrl}/api`,
	apiUniversityUrl,
	apiSchoolUrl,
	fileUrl: '/files/',
	registrationLocalStorageKey: 'registrationGroup',
};
